<template>
    <CompassToggleButtonGroup :value="activeFilter" exclusive @input="handleChange">
        <CompassToggleButton value="all" :label="$t.__('timeline.TimelineEmailFilters.all')" />
        <CompassToggleButton
            value="emailengine.received"
            :label="$t.__('timeline.TimelineEmailFilters.received')"
        />
        <CompassToggleButton
            value="emailengine.sent"
            :label="$t.__('timeline.TimelineEmailFilters.sended')"
        />
        <!-- <CompassToggleButton
            value="emailengine.scheduled.created"
            :label="$t.__('timeline.TimelineEmailFilters.scheduled')"
        />
        <CompassToggleButton value="emailengine.draft.created" :label="$t.__('timeline.TimelineEmailFilters.draft')" />
        <CompassToggleButton value="emailengine.deleted" :label="$t.__('timeline.TimelineEmailFilters.trash')" /> -->
    </CompassToggleButtonGroup>
</template>
<script>
export default {
    props: {
        activeFilter: {
            type: Array,
            required: true,
        },
    },
    methods: {
        handleChange(value) {
            if (value !== '') {
                this.$emit('filterUpdate', [value]);
            }
        },
    },
};
</script>
